import React, { Component } from 'react'

export default class Ranking extends Component {
    render() {
        return (
            <div>
                Ranking
            </div>
        )
    }
}
